__turbopack_context__.v({
  "apps-scroll": "GallerySection-module__nUa1aq__apps-scroll",
  "appsIcon": "GallerySection-module__nUa1aq__appsIcon",
  "appsTrack": "GallerySection-module__nUa1aq__appsTrack",
  "appsViewport": "GallerySection-module__nUa1aq__appsViewport",
  "divider": "GallerySection-module__nUa1aq__divider",
  "galleryItem": "GallerySection-module__nUa1aq__galleryItem",
  "galleryRow": "GallerySection-module__nUa1aq__galleryRow",
});
